
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"68","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71d3b9","d":"M33.937 12.44l17.464 8.438 4.314 18.96-12.086 15.204H24.246L12.16 39.838l4.313-18.96z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M24.737 18.135l16-.08 10.038 12.5-3.482 15.668-14.381 7.037-14.45-6.892-3.639-15.632z"}}),_c('g',[_c('image',{attrs:{"width":"17","height":"16","transform":"translate(25 26)","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAA4ElEQVQ4jZXQMUpDQRDG8fAUQchJrLQQ8QLpxD4gSFqxsbG11QtYCZIipPEwOYKNSiwCNoKoP5t9uIxv98WpZnfm+8/MN8ArhoOeQOM37mNxnhWXFUgbp30NoKP+VKoVIbEZD5UB722yUwPhIpSafHhObPyN79KmtfO7BF/YL+g//uPRG85xjCH2cFUEJMg2XgJoURUVtjjEXQDN+8QbHWdMMcreS+ymfCsCjgrGXWbnPeMg/U86T8jyx9R4HXpawBmmEXASIJ+4LXg1xmbKVyUzYVY1L2ji58064nzjNv8B2HYaGKLNRF8AAAAASUVORK5CYII="}})])])
          )
        }
      }
    